import { z } from "zod";
import type { Enums } from "../../../types/database.types";

export const absenceStates: Enums<"absenceState">[] = [
	"rejected",
	"approved",
	"cancelled",
	"pending",
] as const;

export const patchAbsenceStateSchema = z.object({
	state: z.enum(absenceStates),
});

export type PatchAbsenceStateSchema = z.infer<typeof patchAbsenceStateSchema>;
